(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name bidding.service:BiddingDetailsComponentUiHelper
     *
     * @description
     *
     */
    angular
        .module('bidding')
        .service('BiddingSelectionHelper', BiddingSelectionHelper);

    function BiddingSelectionHelper(CrewingHelper, applicationConstants, BiddingService) {
    	  var self = this;

          var model = {
              timeLineDays: null,
              crewNamesCol: null,
              crewBiddingData : null,
              activeSelections: {
                  BLOCKS : [],
                  CREW_NAMES: [],
                  CREWS : [],
              },
              elementActionMap: {
                  BLOCK: {
                      CLICK: {
                          1: cancelAllPreviousSelections,
                          2: selectBlock,
                          3: selectCrew,
                      },
                      CTRL_CLICK: {
                          1: selectBlock,
                          2: selectCrew,
                      },
                      RIGHT_CLICK: {
                    	  1: cancelPreviousSelectionForBlockRightClick,
                          2: selectBlock,
                          3: selectCrew,
                      },
                      SHIFT_CLICK: {
                          1: selectBlock,
                          2: selectCrew,
                          3: selectAllOtherBlocksInBetween,
                      }
                  },
                  CREW: {
                      CLICK: {
                          1: cancelAllPreviousSelections,
                          2: selectClickedCrew,
                          3: selectAllBlocksForCrew
                      },
                      CTRL_CLICK: {
                          1: selectClickedCrew,
                          2: selectAllBlocksForCrew
                      }
                  }
              }
          };
          
          self.INTERACTION = {
                  CLICK: 'CLICK',
                  RIGHT_CLICK: 'RIGHT_CLICK',
                  SHIFT_CLICK: 'SHIFT_CLICK',
                  CTRL_CLICK: 'CTRL_CLICK',
              };
          
          self.ELEMENT_NAMES = {
                  BLOCK: 'BLOCK',
                  CREW : 'CREW'
              };
          
          function selectClickedCrew() {
              if (angular.isDefined(this.crews)) {
                  var crewObj = getCrewById(this.crews.crewProfId);
                  addCrew(crewObj);
              }
          }

          var getBlockIndex = function (block) { 
              var index = -1;
              var obj;
              for (var i = 0; i < model.activeSelections.BLOCKS.length; i++) {
                  obj = model.activeSelections.BLOCKS[i];
                  if (block == obj) {
                      index = i;
                      break;
                  }
              }
              return index;
          };
          
          var getCrewById = function (crewProfId) {
              return _.find(model.crewBiddingData, {crewProfId: crewProfId});
          };
          
          var getCrewIndex = function (crew) {
              return _.findIndex(model.activeSelections.CREWS, {'crewProfId': crew.crewProfId});
          };


          var addBlock = function (block) { 
              if (getBlockIndex(block) < 0 && !block.approved) {
                  block.isSelected = true;
                  model.activeSelections.BLOCKS.push(block);
              }
          };
          
          var addCrew = function (crew) {
              if (getCrewIndex(crew) < 0) {
                  crew.isSelected = true;
                  model.activeSelections.CREWS.push(crew);
              }
          };


          /**
           * Action main functions
           */

          function cancelAllPreviousSelections() { 
              cancelPreviousBlockSelection();
              cancelPreviousCrewSelection();
          }
          
          function cancelPreviousSelectionForBlockRightClick() {
              if (model.activeSelections.BLOCKS.length > 0) {
                  if (angular.isDefined(this.block)) {
                      if (getBlockIndex(this.block) == -1) {
                          cancelAllPreviousSelections();
                      }
                  }
              } else {
                  cancelAllPreviousSelections();
              }
          }
          
          function cancelPreviousCrewSelection() {
              var crew, i = 0;
              while (model.activeSelections.CREWS.length > 0) {
                  crew = model.activeSelections.CREWS[i];
                  removeCrew(crew);
              }
          }

          var removeCrew = function (crew) {
              var _index = getCrewIndex(crew);
              if (_index >= 0) {
                  crew.isSelected = false;
                  model.activeSelections.CREWS.splice(_index, 1);
              }
          };
          
          function cancelPreviousBlockSelection() { 
              var block, i = 0;
              while (model.activeSelections.BLOCKS.length > 0) {
                  block = model.activeSelections.BLOCKS[i];
                  removeBlock(block);
              }
          }
          
          var removeBlock = function (block) { 
              var _index = getBlockIndex(block);
              if (_index >= 0) {
                  block.isSelected = false;
                  model.activeSelections.BLOCKS.splice(_index, 1);
              }
          };

          
          function selectCrew() {
              if (angular.isDefined(this.crews)) {
                  addCrewToActiveSelection(this.crews);
              }
          }
          
          function selectBlock() { 
              if (angular.isDefined(this.block)) {
                  addBlockToActiveSelection(this.block);
              }
          }

          function selectAllOtherBlocksInBetween() { 
              var selectedBlocks = model.activeSelections.BLOCKS;
              var startBlock = self.getFirstBlock(selectedBlocks);
              var endBlock = self.getLastBlock(selectedBlocks);

              var blocks;
              var crews = BiddingService.getCrews(model.activeSelections.CREWS);
              angular.forEach(crews, function (crew) {
                  blocks = BiddingService.getBlocksForCrew(crew.crewProfId, startBlock.biddingDate, endBlock.biddingDate);
                  angular.forEach(blocks, function (b) {
                      addBlock(b);
                  });
              });
          }
          
          function selectAllBlocksForCrew(){
              angular.forEach(model.activeSelections.CREWS, function (crew) {
                  angular.forEach(crew.biddingData, function (b) {
                      addBlock(b);
                  });
              });
          }
          
          self.getFirstBlock = function(selectedBlocks) {
        	  return selectedBlocks.reduce(function (previous, current) {
                  if (previous == null) {
                      return current;
                  } else {
                      var last = moment(previous.biddingDate, applicationConstants.SETTINGS.DATE_FORMAT);
                      var now = moment(current.biddingDate, applicationConstants.SETTINGS.DATE_FORMAT);
                      if (now.isBefore(last)) {
                          return current;
                      } else {
                          return previous;
                      }
                  }
              }, null);
          }
          
          self.getLastBlock = function(selectedBlocks) {
        	  return selectedBlocks.reduce(function (previous, current) {
                  if (previous == null) {
                      return current;
                  } else {
                      var last = moment(previous.biddingDate, applicationConstants.SETTINGS.DATE_FORMAT);
                      var now = moment(current.biddingDate, applicationConstants.SETTINGS.DATE_FORMAT);
                      if (now.isAfter(last)) {
                          return current;
                      } else {
                          return previous;
                      }
                  }
              }, null);
          }

          /**
           * Make block or collection of blocks selected
           * @param blocks
           */
          function addBlockToActiveSelection(blocks) {
        	  if (blocks instanceof Array) {
                  angular.forEach(blocks, function (d) {
                	  addBlock(d);
                  });
              } else {
            	  addBlock(blocks);
              }
          }
          
          /**
           * make crew or collection of crews selected
           * @param crews - {} or []
           */
          function addCrewToActiveSelection(crews) {
              if (crews instanceof Array) {
                  angular.forEach(crews, function (c) {
                      addCrew(c);
                  });
              } else {
                  addCrew(crews);
              }
          }

          /**
           * Public Api
           *
           */
          self.performAction = function (elementType, actionType, context) {
              if (model.elementActionMap[elementType] && model.elementActionMap[elementType][actionType]) {
                  var actionMap = model.elementActionMap[elementType][actionType];
                  if (!!actionMap) {
                      angular.forEach(Object.keys(actionMap), function (key) {
                          actionMap[key].call(context);
                      });
                  }
              }
          };
          
          self.getSelectedBlocks = function () {
              return model.activeSelections.BLOCKS;
          };
          
          self.setSelectedBlocks = function (blocks) {
              model.activeSelections.BLOCKS = blocks;
          };

          self.getCrewNames = function () {
              return model.activeSelections.CREWS;
          };
          
          self.setCrewBiddingData = function (crewBidding) {
              model.crewBiddingData = crewBidding;
          };
          
          self.cancelPreviousSelections = function() {
        	  cancelAllPreviousSelections();
          }
          
      }
}());
